import { Component, Input, OnInit } from '@angular/core';
import { CompanyOwnershipService } from 'src/modules/shared/services/company-ownership.service';
import { DashboardProvider } from '../../../services';
@Component({
  selector: 'app-dashboard-record',
  templateUrl: './dashboard-record.component.html',
  styleUrls: ['./dashboard-record.component.scss'],
})
export class DashboardRecordComponent implements OnInit {
  pending: boolean;
  error: any;
  success: any;
  records: Array<any> = [];
  @Input() record;
  @Input() companyDetail;
  @Input() loading: boolean;
  @Input() isBusinessName;
  status: Object;
  rcStatus: any;
  addressStatus: any;
  tinStatus: any;
  tccStatus: any;
  contactStatus: any;
  nameStatus: any;
  docStatus: any;
  shareholders: any;
  directors: any;
  equipmentStatus: any;
  allAffiliateTypes!: any[];
  companyAffiliateTypes!: any[];
  totalApiCalls = 4;
  callsCompleted = 0;
  organizationDetails: any;
  personnelStructureKeys = [];
  companyTypeId;
  permissions: Array<any> = [];
  regStatus = 'EMPTY';
  otherTinStatus: any;
  otherTccStatus: any;
  ownershipType;
  constructor(
    private dashboardSvc: DashboardProvider,
    private companyOwnershipService: CompanyOwnershipService
  ) {
    this.organizationDetails = JSON.parse(
      window.localStorage.getItem('organization')
    );
    this.ownershipType =
      this.organizationDetails.jpaContractor.ownershipType.optionId;
    this.companyTypeId = this.organizationDetails.jpaContractor.companyType
      ? this.organizationDetails.jpaContractor.companyType.parentOptionId
          ?.optionId ||
        this.organizationDetails.jpaContractor.companyType?.optionId
      : '';
    // this.getAffiliateTypes(this.companyTypeId);
    // this.getAllAfiliateTypes();
    this.getVerificationStatus();
    if (window.localStorage.getItem('permission')) {
      this.permissions = JSON.parse(window.localStorage.getItem('permission'));
    }
  }

  callCompleted() {
    this.callsCompleted++;
    if (this.callsCompleted >= this.totalApiCalls) {
      this.pending = false;
    }
  }
  checkPermission(id: string, action: string): boolean {
    if (
      this.permissions.filter((res) => res.permissionId === id)[0] &&
      this.permissions.filter((res) => res.permissionId === id)[0][action] ===
        'true'
    ) {
      return true;
    } else {
      return false;
    }
  }

  getVerificationStatus() {
    this.pending = true;
    this.dashboardSvc
      .getStatus({
        organizationId: this.organizationDetails.organizationId,
      })
      .subscribe(
        (res) => {
          this.status = res;
          this.personnelStructureKeys = Object.keys(res).filter((key) =>
            key.includes('STRUCTURE')
          );
          this.getAffiliateTypeVerificationStatus();
          this.rcStatus = res['RC_NUMBER'];
          this.addressStatus = res['ADDRESS'];
          this.tinStatus = res['TIN'];
          this.tccStatus = res['TCC'];
          this.otherTccStatus = res['OTHER_TCC']
            ? res['OTHER_TCC']
            : 'NOT_AVAILABLE';
          this.otherTinStatus = res['OTHER_TIN'];
          this.pending = false;
          console.log(
            this.rcStatus,
            this.addressStatus,
            this.tinStatus,
            this.tccStatus,
            this.otherTccStatus,
            this.otherTinStatus
          );
        },
        (error) => {
          this.rcStatus = 'NOT_AVAILABLE';
          this.addressStatus = 'NOT_AVAILABLE';
          this.tinStatus = 'NOT_AVAILABLE';
          this.tccStatus = 'NOT_AVAILABLE';
          this.otherTccStatus = 'NOT_AVAILABLE';
          this.otherTinStatus = 'NOT_AVAILABLE';
          this.error = 'Error occured in loading company records';
          console.log('error occured in this component');
          this.pending = false;
        }
      );
  }

  getAffiliateTypeVerificationStatus() {
    if (this.personnelStructureKeys && this.companyAffiliateTypes?.length) {
      this.companyAffiliateTypes.forEach((affiliateType) => {
        let statusKey = this.personnelStructureKeys.find((key) => {
          return key
            .toLowerCase()
            .includes(affiliateType.ownershipType.toLowerCase());
        });
        affiliateType.status = statusKey ? this.status[statusKey] : '';
      });
    }
  }

  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId == 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId: companyTypeId })
      .subscribe(
        (res: any[]) => {
          this.callCompleted();
          this.companyAffiliateTypes = res;
          console.log(this.companyAffiliateTypes, 'this.companyAffiliateTypes');
          this.getAffiliateTypeVerificationStatus();
        },
        (error) => {
          this.callCompleted();
          console.log(error);
        }
      );
  }

  getAllAfiliateTypes() {
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
        let t = setInterval(() => {
          if (this.pending == false) {
            clearInterval(t);
          }

          if (this.companyAffiliateTypes) {
            this.companyAffiliateTypes.forEach((companyAffiliateType) => {
              this.allAffiliateTypes.every((affiliateType) => {
                if (
                  companyAffiliateType.ownershipType == affiliateType.optionName
                ) {
                  companyAffiliateType.ownershipTypeId = affiliateType.optionId;
                  return false;
                }
                return true;
              });
            });
            this.callCompleted();
            clearInterval(t);
          }
        }, 200);
      },
      (error) => {
        this.callCompleted();
        console.log(error);
      }
    );
  }

  ngOnInit(): void {}
}
